import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { steps } from '../data/content';
export function HowItWorksTeaser() {
  return <section id="how-it-works" aria-labelledby="how-it-works-teaser-title" className="scroll-mt-20 border-b border-white/5 bg-ink-900" data-id="element-113" data-mp="mspqbfye5thn">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-114" data-mp="rq95ci2wyaan">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-115" data-mp="d1v3oah8grvo">
          <div className="max-w-2xl" data-id="element-116" data-mp="htwavhzjnseu">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-117" data-mp="huxptxjokz1u">
              How it works
            </p>
            <h2 id="how-it-works-teaser-title" className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-118" data-mp="91cbgfbfhjsy">
              Three steps between your lead spend and a booked appointment.
            </h2>
          </div>
          <Link to="/how-it-works" className="group inline-flex flex-none items-center gap-2 rounded text-sm font-semibold text-brand transition-colors hover:text-brand-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-119" data-mp="2fczyq6tdkfhl">
            See the full system
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-120" data-mp="2kccnix3t3wmt" />
          </Link>
        </div>

        <ol className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-121" data-mp="1rnnpx81ym9ft">
          {steps.map(step => <li key={step.number} className="rounded-xl border border-white/10 bg-ink-800 p-6" data-id="element-122" data-mp="25ek804y9f88m">
              <span className="font-display text-sm font-semibold tracking-widest text-brand" data-id="element-123" data-mp="20naj56kjc8xs">
                {step.number}
              </span>
              <h3 className="mt-4 font-display text-lg font-semibold tracking-tight text-white" data-id="element-124" data-mp="1cw57l3lmo2ta">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-white/55" data-id="element-125" data-mp="380mq1ybtyl8k">
                {step.body.split('. ').slice(0, 2).join('. ')}.
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}